import { TrialBanner } from "./banner";

import { useTrial } from "hooks/use-trial";

const TrialTimeBanner: React.FC = (): JSX.Element | null => {
  const trialData = useTrial();

  if (
    trialData === null ||
    trialData.trial.completed ||
    trialData.remainingDays < 0
  ) {
    return null;
  }

  const { remainingDays } = trialData;

  return <TrialBanner remainingDays={remainingDays} />;
};

export { TrialTimeBanner };
